import { apiService } from '../../../client/common/apiCallService';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { useJunoCommonFunctions } from '../../../client/Juno/helpers';
import JunoForm from '../common/JunoForm';

const REDIRECT_DELAY = 5000;

const Password = ({ setSuccess }) => {
    const apiUrl = useSelector(state => state.config.api_url);
    const clientData = useSelector(state => state.juno.clientData);
    const { logout } = useJunoCommonFunctions();

    const [form, setForm] = useState({
        current: '',
        new: '',
        confirm: '',
        showNew: false,
        showConfirm: false,
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = (event = {}, op, field) => {
        if (op == 'bool') {
            return setForm(prev => ({
                ...prev,
                [field]: !prev[field],
            }));
        }

        const { name, value } = event.target;

        if (errors) {
            setErrors(null);
        }

        setForm(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const fields = [
        {
            label: 'current password',
            name: 'current',
            type: 'password',
            value: form.current,
            placeholder: 'enter current password',
            visibileIcon: false,
            isRequired: true,
            autoComplete: 'new-password',
        },
        {
            label: 'new password',
            name: 'new',
            placeholder: 'enter new password',
            type: form.showNew ? 'text' : 'password',
            value: form.new,
            visibileIcon: true,
            visibilityKey: 'showNew',
            isRequired: true,
        },
        {
            label: 'confirm password',
            name: 'confirm',
            placeholder: 'confirm password',
            value: form.confirm,
            type: form.showConfirm ? 'text' : 'password',
            visibileIcon: true,
            visibilityKey: 'showConfirm',
            isRequired: true,
        },
    ];

    const handleSave = () => {
        let errorObj = {};

        if (!form.current) {
            errorObj.current = 'Current password is a required field.';
        }

        if (!form.new) {
            errorObj.new = 'New password is a required field.';
        }

        if (!form.confirm) {
            errorObj.confirm = 'Confirm password is a required field.';
        }

        if (form.confirm && form.new && form.confirm != form.new) {
            errorObj.confirm = 'New and Confirm password does not match.';
        }

        if (Object.keys(errorObj).length) {
            setErrors(errorObj);
        } else {
            setLoading(true);
            try {
                apiService(
                    (window.location.hostname === 'localhost' ? apiUrl : '') +
                        '/restapi/changePassword-client',
                    {
                        clientEmail: clientData.clientEmail,
                        oldPassword: form.current,
                        newPassword: form.new,
                    },
                    () => {
                        setSuccess(true);
                        setForm({
                            current: form.new,
                            new: '',
                            confirm: '',
                            showNew: false,
                            showConfirm: false,
                        });
                        setTimeout(() => {
                            logout();
                        }, REDIRECT_DELAY);
                    },
                    err => {
                        setErrors({
                            [err?.includes('Existing') ? 'current' : 'new']: err,
                        });
                        setLoading(false);
                    },
                );
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <JunoForm
            fields={fields}
            handleChange={handleChange}
            errors={errors}
            formData={form}
            loading={loading}
            disabled={
                loading ||
                Object.keys(errors || {})?.length ||
                !(form.current && form.new && form.confirm)
            }
            onBottomClick={handleSave}
            buttonClassName="mt-12 font-medium"
        />
    );
};

Password.propTypes = {
    setSuccess: PropTypes.func.isRequired,
};

export default Password;
